module.exports = __webpack_public_path__ + "img/05.6b853c9a.png";